export function getUserFromLocalStorage() {
  try {
    const userData = localStorage.getItem("@azure:user");
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
    return null;
  }
}
